var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Minus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3.2460938 10.992188 A 1.250125 1.250125 0 1 0 3.2460938 13.492188 L 20.755859 13.492188 A 1.250125 1.250125 0 1 0 20.755859 10.992188 L 3.2460938 10.992188 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Minus);
export default __webpack_public_path__ + "static/media/icons8-minus.116bcfbfe4a5b48d8e58c7d601ef3787.svg";
export { ForwardRef as ReactComponent };